import { MdOutlineFavorite, MdOutlineFavoriteBorder } from "react-icons/md";
import { usePost, usePostValue } from "../../..";
import { useStateReducer } from "../../../../../hooks/useStateReducer";
import { fetchLikePost } from "../../../api";
import UActionButton from "../../../UI/UActionButton";

type Props = {};

const LikeButton = (props: Props) => {
  const [state, setState] = useStateReducer({ isLoading: false });

  const { setOne: setPostOne, get: getPost } = usePost();
	const isLiked = usePostValue((s) => s.post.isLiked)
	const likes = usePostValue((s) => s.post.likes)
  // const post = usePostValue((s) => s.post);

  const handleLikePost = () => {
    setState({ isLoading: true });
    fetchLikePost(getPost().post._id)
      .then(({ status, data }) => {
        if (status == 200) setPostOne('post', (v) => ({...v, ...data}));
      })
      .finally(() => {
        setState({ isLoading: false });
      });
  };

  return (
    <UActionButton disabled={state.isLoading} onClick={handleLikePost}>
      {isLiked ? <MdOutlineFavorite /> : <MdOutlineFavoriteBorder />}
      <span>{likes}</span>
    </UActionButton>
  );
};

export default LikeButton;
